<template lang="pug">
  .layout
    y-dialog(v-model="showModal" persistent max-width="320")
      v-card
        v-card-text.p2.primary500--text.px-6.pt-8 {{ $t('message', { orderNumber }) }}
        v-card-actions.pb-4.px-4
          v-spacer
          v-btn.button-Aa-small.primary400--text(text @click="showModal = false") {{ $t('cancel') }}
          v-btn.button-AA-tiny.danger500.basic100--text(small depressed :loading="loading" @click="loading = true; $emit('cancelOrder')") {{ $t('confirm') }}
</template>

<script>
  export default {
    name:'ConfirmCancelLocalDelivery',
    props: {
      open: {
        type: Boolean,
      },
      orderNumber: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      showModal: {
        get() {
          return this.open 
        },
        set(val) {
          this.$emit('update:open', val)
        }
      }
    },
  }
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "message": "Are you sure you want to cancel local delivery arrangement for order {orderNumber}?",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "id": {
    "message": "Anda yakin ingin membatalkan pengaturan pengiriman lokal untuk pesanan {orderNumber}",
    "cancel": "Batal",
    "confirm": "Konfirmasi"
  }
}
</i18n>